<template>
  <div v-if="isVisible" class="modal-overlay" @click.self="close">
    <div class="dialog-body">
      <div class="head-body" @click="close">
        关闭
      </div>
      <div class="content-body">
        <div class="item-body" v-for="(item, index) in uploadTaskList" :key="index">
          <!-- {{ item.title }} -->
          <div class="item-img">
            <img :src="$fileIcon(item.title)" alt="" />
          </div>
          <div class="item-content">
            <div class="title">
              {{ item.title }}
            </div>
            <div class="time">
              {{ $formatDate(item.time) }}
            </div>
            <div class="progress-container">
              <div class="progress-bar">
                <div class="progress" :style="{ width: item.progress + '%' }">
                </div>
              </div>
            </div>
          </div>
          <div class="status" @click="clickItemStatus(item)">
            {{ statusMap[item.status] }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
  // 例如：import 《组件名称》 from '《组件路径》';
  export default {
    // import引入的组件需要注入到对象中才能使用
    components: {},
    props: {
      uploadTaskList: [],
      isVisible: {
        type: Boolean,
        default: false
      }
    },
    data() {
      // 这里存放数据
      return {
        statusMap: {
          // 0 创建 1 上传中 2 暂停 3 完成 4 失败 5 并行暂停（限制并行下载上传数量，当有空闲时，会自动恢复）
          0: '创建',
          1: '上传',
          2: '暂停',
          3: '完成',
          4: '失败',
          5: '等待'
        }
      }
    },
    // 过滤器
    filters: {},
    // 监听属性 类似于data概念
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
      close() {
        this.$emit('update:isVisible', false);
      },
      clickItemStatus(item) {
        if (item.status == 3 || item.status == 4) return;
        if (item.status == 0 || item.status == 1) {
          // 暂停上传
          this.$emit('pauseUpload', item);
        } else {
          // 恢复上传
          this.$emit('resumeUpload', item);
        }
      }
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {},
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {},
    beforeCreate() {}, // 生命周期 - 创建之前
    beforeMount() {}, // 生命周期 - 挂载之前
    beforeUpdate() {}, // 生命周期 - 更新之前
    updated() {}, // 生命周期 - 更新之后
    beforeDestroy() {}, // 生命周期 - 销毁之前
    destroyed() {}, // 生命周期 - 销毁完成
    ctivated() {} // 如果页面有keep-alive缓存功能，这个函数会触发
  }
</script>

<style lang='scss' scoped>
  .modal-overlay {
    position: fixed;
    /* top: 0; */
    /* left: 0; */
    right: 30px;
    bottom: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    .dialog-body {
      width: 452px;
      height: 300px;
      background-color: white;
      border-radius: 14px;
      box-shadow: -10px 4px 7px 4px rgba(68,68,68, .2);
      display: flex;
      flex-direction: column;
      padding: 0 24px;
      .head-body {
        height: 30px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        font-size: 13px;
      }
      .head-body:hover {
        cursor: pointer;
      }
      .content-body {
        flex: 1;
        overflow-y: auto; /* 允许垂直滚动 */
        /* 隐藏滚动条 */
        &::-webkit-scrollbar {
          display: none;  /* 隐藏滚动条 */
        }
        .item-body {
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          .item-img {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 24px;
            height: 24px;
            margin-right: 10px;
            img {
              width: 24px;
              height: 24px;
            }
          }
          .item-content {
            font-size: 13px;
            flex: 1;
            .time {
              font-size: 10px;
              color: #999;
            }
            .progress-container {
              width: 100%;

              .progress-bar {
                width: 100%;
                background-color: rgba(0, 0, 0, 0.08);
                border-radius: 5px;
                height: 4px;
                overflow: hidden;

                .progress {
                  height: 100%;
                  background-color: #4A83FF;
                  transition: width 0.3s ease;
                  border-radius: 8px 0 0 8px;
                }
              }
            }
          }
          .status {
            font-size: 13px;
            margin-left: 10px;
          }
          .status:hover{
            cursor: pointer;
          }
        }
      }
    }
  }
  .title {
    word-break: break-all;
    word-wrap: break-word;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    line-height: 1.2;
    max-height: 2.4em;
  }
</style>



// WEBPACK FOOTER //
// src/components/upload_progress_dialog.vue